'use strict';

frontendApp.directive('iioNotifications', ['NotificationService', function(NotificationService) {
    return {
        restrict:'E',
        templateUrl: 'partials/notifications.html',
        link: function(scope, element, attrs) {
            scope.notifications = NotificationService;
            
        }
    }
}]);
